import PageHeader from "../components/layout/PageHeader";
import SectionTitle from "../components/common/SectionTitle";
import { TaxiCard } from "../components/common/Cards";
import CtaBanner from "../components/common/CtaBanner";
import { taxis } from "../data/content";

export default function Taxis() {
  return (
    <>
      <PageHeader title="Our Taxis" crumbs={[{ label: "Taxis" }]} />
      <section className="section">
        <div className="container">
          <SectionTitle
            subtitle="Our Fleet"
            title="Choose the Ride That <span>Fits Your Journey</span>"
            text="A diverse, well-maintained fleet to match every need and budget."
          />
          <div className="grid grid-3">
            {taxis.map((t) => <TaxiCard key={t.id} taxi={t} />)}
          </div>
        </div>
      </section>
      <CtaBanner />
    </>
  );
}
